/**
 * Parse a list of contacts into a Map keyed by project resource name.
 *
 * @param {Array} contacts - Array of contact objects with .name, .email, .phoneNumber
 * @returns {Map<string, {hasEmails: boolean, hasPhones: boolean, count: number}>}
 */
export function parseContactsByProject(contacts) {
    const byProject = new Map();
    contacts.forEach(contact => {
        // contact.name format: "projects/{projectId}/contacts/{contactId}"
        const parts = contact.name.split('/');
        const projectName = parts.length >= 2 ? `projects/${parts[1]}` : null;
        if (!projectName) return;

        if (!byProject.has(projectName)) {
            byProject.set(projectName, { hasEmails: false, hasPhones: false, count: 0 });
        }
        const projectInfo = byProject.get(projectName);
        projectInfo.count += 1;
        if (contact.email && contact.email.trim() !== '') projectInfo.hasEmails = true;
        if (contact.phoneNumber && contact.phoneNumber.trim() !== '') projectInfo.hasPhones = true;
    });
    return byProject;
}

/**
 * Build a contact group info summary from a list of contacts.
 *
 * @param {Array} contacts - Array of contact objects
 * @returns {{ totalContacts: number, hasEmails: boolean, hasPhones: boolean, byProject: Map }}
 */
export function buildContactGroupInfo(contacts) {
    return {
        totalContacts: contacts.length,
        hasEmails: contacts.some(c => c.email && c.email.trim() !== ''),
        hasPhones: contacts.some(c => c.phoneNumber && c.phoneNumber.trim() !== ''),
        byProject: parseContactsByProject(contacts)
    };
}
